import geocoderService from "../shared/services/geocoderService";

const REQUEST_GEOCODER_SEARCH = "REQUEST_GEOCODER_SEARCH";
const RESPONSE_GEOCODER_SEARCH = "RESPONS_GEOCODER_SEARCH";
const REQUEST_GEOCODER_SEARCH_FAILURE = "REQUEST_GEOCODER_SEARCH";

const requestGeocoderSearchAction = (data) => {
  return {
    type: REQUEST_GEOCODER_SEARCH,
  };
};

const responseGeocoderSearchAction = (data) => {
  return {
    type: RESPONSE_GEOCODER_SEARCH,
    data,
  };
};

const requestGeocoderSearchFailureAction = (errors) => {
  return {
    type: REQUEST_GEOCODER_SEARCH_FAILURE,
    errors,
  };
};

const geocoderSearch = (options) => {
  return (dispatch) => {
    dispatch(requestGeocoderSearchAction(options.query));

    geocoderService
      .search(options)
      .then((result) => {
        dispatch(responseGeocoderSearchAction(result.data));
        dispatch(unselectGeocoderSearch());
      })
      .catch((error) => {
        dispatch(requestGeocoderSearchFailureAction(error.response));
      });
  };
};

const SELECT_GEOCODER_SEARCH = "SELECT_GEOCODER_SEARCH";

const selectGeocoderSearchAction = (data) => {
  return {
    type: SELECT_GEOCODER_SEARCH,
    data,
  };
};

const selectGeocoderSearch = (item) => {
  return (dispatch) => {
    dispatch(selectGeocoderSearchAction(item));
  };
};

const UNSELECT_GEOCODER_SEARCH = "UNSELECT_GEOCODER_SEARCH";

const unselectGeocoderSearchAction = () => {
  return {
    type: UNSELECT_GEOCODER_SEARCH,
  };
};

const unselectGeocoderSearch = () => {
  return (dispatch) => {
    dispatch(unselectGeocoderSearchAction());
  };
};

const CLEAR_GEOCODER_SEARCH = "CLEAR_GEOCODER_SEARCH";

const clearGeocoderSearchAction = () => {
  return {
    type: CLEAR_GEOCODER_SEARCH,
  };
};

const clearGeocoderSearch = () => {
  return (dispatch) => {
    dispatch(clearGeocoderSearchAction());
  };
};

const SET_GEOCODER_SEARCH_DATA = "SET_GEOCODER_SEARCH_DATA";

const setGeocoderSearchDataAction = (data) => {
  return {
    type: SET_GEOCODER_SEARCH_DATA,
    data,
  };
};

const setGeocoderSearchData = (data) => {

  return (dispatch) => {
    dispatch(setGeocoderSearchDataAction(data));
  };
};

export {
  REQUEST_GEOCODER_SEARCH,
  RESPONSE_GEOCODER_SEARCH,
  REQUEST_GEOCODER_SEARCH_FAILURE,
  geocoderSearch,
  SELECT_GEOCODER_SEARCH,
  selectGeocoderSearch,
  UNSELECT_GEOCODER_SEARCH,
  unselectGeocoderSearch,
  CLEAR_GEOCODER_SEARCH,
  clearGeocoderSearch,
  SET_GEOCODER_SEARCH_DATA,
  setGeocoderSearchData,
};
